import cx from 'classnames';

import { Calendar } from '../../../design-system/Icons/Calendar';
import { LocationOn } from '../../../design-system/Icons/LocationOn';
import { MonetizationOn } from '../../../design-system/Icons/MonetizationOn';

import s from './TripInformations.module.css';

type TripInformationsProps = {
    destination: string;
    year: number;
    budget?: string;
};

type Props = {
    informations: TripInformationsProps;
    className?: string;
};

export const TripInformations = ({
    informations: { destination, year, budget },
    className,
}: Props) => {
    return (
        <div className={cx(s.informations, className)}>
            <span className={s.badge}>
                <LocationOn color={'var(--ink)'} />
                {destination}
            </span>
            <span className={s.badge}>
                <Calendar color={'var(--ink)'} />
                {year}
            </span>
            {budget && (
                <span className={s.badge}>
                    <MonetizationOn color={'var(--ink)'} />
                    {budget}
                </span>
            )}
        </div>
    );
};
